
export default {
  data() {
    return {
      isLoading: false,
      form: {
        email: '',
      },
    }
  },

  head() {
    return {
      title: 'Passwort vergessen',
    }
  },

  methods: {
    reset() {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      this.$axios
        .$post('/auth/password-forgot', this.form)
        .then(() => {
          this.$refs.form.reset()

          this.$toast.success(
            'Sie erhalten eine E-Mail mit weiteren Instrukionen.'
          )

          this.form.email = ''
        })
        .catch(({ response }) => {
          this.$refs.form.setErrors(response.data.errors)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
